<div fxLayout="row" fxLayoutAlign="center center" class="mb-20">
  <div fxLayout="column" fxFlex="80%"
    fxLayoutAlign="space-around stretch" fxLayoutGap="20px">
    <br />
    <br />
    <h1 name="hdw-header" class="mat-h1"><b i18n="@@button-info-how">How does it work?</b></h1>
    <div fxLayout.xs="column" fxLayout.sm="column" fxLayoutAlign="start start" fxLayoutGap="5%">
      <div fxLayout.xs="column" fxLayout.sm="column" fxLayout="row wrap" fxFlex="100%" fxLayoutAlign="center" fxLayoutGap.xs="20px" fxLayoutGap.sm="20px">
        <mat-card fxFlex="93%" class="mat-elevation-z4 hdw-card">
          <mat-card-content fxFlex="100%" fxLayout="column" fxLayoutGap="20px" class="hdw-card-content">
              <p i18n="@@courses-are-added">Courses are added to suit individual needs, so only materials that are relevant to <b>you</b> will be in your course list.</p>
              <p i18n="@@after-you-login">After you log in, view the area called ‘My courses’. Just choose the course you want to start working through from the list.</p>
              <p i18n="@@when-you-have-done">When you have done what you have time for, leave the course and go back to ‘My courses’. All your answers will be stored ready for the next time you go back to the course. Or you can start to learn with a new course.</p>
              <span>
                <p i18n="@@wales-essential"><b>Wales Essential Skills Toolkit</b> courses are web-based, so you can get to them:</p>
                <ul>
                  <li i18n="@@any-day">any day, any time</li>
                  <li i18n="@@on-almost">on almost any computer, anywhere in the world, so long as it is connected to the Internet.</li>
                </ul>
              </span>
              <p i18n="@@look-after-someone">So even if you look after someone in your family, work shifts, or just have a really busy social life, you can still arrange your learning for a time that suits you. The more time you spend learning, the quicker you will improve your skills.</p>
            </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div *ngIf="isLoggedIn && (userProfile$ | async)?.roleId == learnerRole" class="browser-note" name="browser-note-container">
      <app-browser-note></app-browser-note>
    </div>
  </div>
</div>
